import { createWebHashHistory, createRouter } from 'vue-router'

/** DEFAULT **/
const Homepage = () => import( '@/components/routes/Homepage.vue' );
const Legal = () => import( '@/components/routes/Legal.vue' );
const Imprint = () => import( '@/components/routes/Imprint.vue' );
const Contact = () => import( '@/components/routes/Contact.vue' );
const Pricing = () => import( '@/components/routes/Pricing.vue' );
const Activation = () => import( '@/components/routes/Activation.vue' );
const Maintenance = () => import( '@/components/routes/Maintenance.vue' );

/** LOGGED IN **/
const Dashboard = () => import( '@/components/routes/Dashboard.vue' );
const Profile = () => import( '@/components/routes/Profile.vue' );
const Mailbox = () => import( '@/components/routes/Mailbox.vue');
const MatchMaker = () => import( '@/components/routes/MatchMaker.vue' );
const Chat = () => import( '@/components/routes/Chat.vue' );
const Shoutboard = () => import( '@/components/routes/Shoutboard.vue' );
const Settings = () => import( '@/components/routes/Settings.vue' );
const Help = () => import( '@/components/routes/Help.vue' );
const Admin = () => import( '@/components/routes/Admin.vue' );


/* eslint-disable */
const routes = [
    {
        path:      '/',
        name:      'default',
        component: Homepage
    },
    {
        path:      '/legal',
        name:      'legal',
        component: Legal
    },
    {
        path:      '/contact',
        name:      'contact',
        component: Contact
    },
    {
        path:      '/pricing',
        name:      'pricing',
        component: Pricing
    },
    {
        path:      '/imprint',
        name:      'imprint',
        component: Imprint
    },
    {
        path:      '/dashboard',
        name:      'dashboard',
        component: Dashboard
    },
    {
        path:      '/profile',
        name:      'profile',
        component: Profile
    },
    {
        path:      '/mailbox',
        name:      'mailbox',
        component: Mailbox
    },
    {
        path:      '/matchmaker',
        name:      'matchmaker',
        component: MatchMaker
    },
    {
        path:      '/chat',
        name:      'chat',
        component: Chat
    },
    {
        path:      '/shoutboard',
        name:      'shoutboard',
        component: Shoutboard
    },
    {
        path:      '/settings',
        name:      'settings',
        component: Settings
    },
    {
        path:      '/help',
        name:      'help',
        component: Help
    },
    {
        path:      '/admin',
        name:      'admin',
        component: Admin
    },
    {
        path:      '/activate',
        name:      'activate',
        component: Activation
    },
    {
        path:      '/activate/:key/',
        name:      'activate',
        component: Activation
    },
    {
        path:      '/maintenance',
        name:      'maintenance',
        component: Maintenance
    }
]

const router = createRouter( {
    routes,
    history: createWebHashHistory(),
    scrollBehavior( to, from, savedPosition )
    {
        if ( to.hash ) {
            return {
                selector: to.hash,
                behavior: 'smooth'
            }
        }
    }
} )

router.beforeEach( ( to, from, next ) =>
{
    
    let routesAllowed = [
        'default',
        'maintenance',
        'register',
        'login',
        'pricing',
        'contact',
        'imprint',
        'privacy',
        'legal',
        'help',
        'activate'
    ]
    
    let element = document.querySelector( '#header' )
    if ( null !== element ) {
        element.scrollIntoView( { behavior: 'smooth' } )
    }
    
    if ( -1 < routesAllowed.indexOf( to.name ) ) {
        next()
    } else {
        if ( undefined === window.authKey ) {
            setTimeout( () =>
            {
                if ( null !== window.authKey
                     && undefined !== window.authKey ) {
                    next()
                } else {
                    next( { name: 'default' } )
                }
            }, 200 )
        } else {
            if ( null !== window.authKey ) {
                next()
            } else {
                next( { name: 'default' } )
            }
        }
        
    }
    
} )

export default router